module.exports = __webpack_public_path__ + "img/tervezhetoseg_kep_1920.1bf86e23.png";